import { getSimplifiedWordLevels } from "#get-simplified-word-levels";
import { getTraditionalWordLevels } from "#get-traditional-word-levels";
import type { WordLevel } from "@-/dev.improve.haniverse.lib.level";

/** HSK 3.1 vocabulary, ordered by the selected script's character curriculum. */
export function getWordLevels(script: "simplified" | "traditional"): readonly WordLevel[] {
  return script === "traditional" ? getTraditionalWordLevels() : getSimplifiedWordLevels();
}
